export default __webpack_public_path__ + "static/media/yogabot_realidad.e4b0fd2a.png";